module.exports = __webpack_public_path__ + "img/myposition_dm_세르히오 부스케츠.ceccd439.png";